import { sportingAPI } from 'services/sporting/api';

export const getNewSportApplicationsCount = async (): Promise<number> => {
  const applicationIds = await sportingAPI.service.getNewShootingClaimsCount();

  return applicationIds.length;
};
